/**********************************
 * 重要，重要，重要
 * 如需使用方向判断， 需要在vue - router源码中找到genKey方法，
 * 源码方法为：
 * function genKey () {
 *     return Time.now().toFixed(3)
 * }
 * 把上面返加值改成
 *     return Date.now()
 */

/** 
 * 在 vue-router 3.0.1(及以上版本可用) 的基础上进行扩展改造
 * 重写了原型链上的'push'、'replace'方法, 
 * 以便在路由跳转时可以做一些统一处理;
 */

import vue from '../vue-event/vue-event.js'
import fr from './data.js'

var VR = VueRouter,
    key = null,
    Fe_Router_Bus = Vue.extend({
        name: 'x3-router-bus',
        template: '<div style="width:0; height: 0; display: none; opacity: 0;">路由总线</div>',
        beforeRouteEnter(to, from, next) {
            // console.log('... mixin router-bus enter ....');
            next();
        },
        beforeRouteUpdate(to, from, next) {
            // console.log('... mixin router-bus update ....');
            next();
            fr.routeType = 'update'
        },
        beforeRouteLeave(to, from, next) {
            // console.log('... mixin router-bus leave ....');
            next();
            fr.routeType = 'goto'
        }
    })

function transRoutes(routes) {
    var bus = () => Promise.resolve(Fe_Router_Bus)
    routes.forEach(route => {
        if (!route.meta) {
            route.meta = {
                page: route.component
            }
        } else if (!route.meta.page) {
            route.meta.page = route.component
        }
        route.component = bus
    })

    return routes
}

VueRouter = function VueRouter(options) {
    options.routes = transRoutes(options.routes)
    VR.call(this, options)
    vue.$emit('instanceVueRouter', this)
}


for (key in VR) {
    if (VR.hasOwnProperty(key)) {
        VueRouter[key] = VR[key]
    }
}

VueRouter.prototype = VR.prototype

// 对原生vue-router的'push','replace'方法重写
VueRouter.prototype.push = function push(location, onComplete, onAbort) {
    /**
     * 这里加个定时器，是为了每次变更时，可以在不同的事件周期内得到执行，目的是可以让连续多次的路由变化得到响应。
     * 如： router.push("/a");router.push("/b");
     */
    setTimeout(() => {
        // console.log("vx-router push  ...");
        location = this.formatLocation(location, 'push', 'forward');

        this.history.push(location, onComplete, function (err) {
            console.warn(err);
            onAbort && onAbort(err);
        })
    }, 0)
}

VueRouter.prototype._replace = function _replace(location, onComplete, onAbort, dire) {
    setTimeout(() => {
        // console.log("vx-router replace  ....");
        location = this.formatLocation(location, "replace", dire);

        this.history.replace(location, onComplete, function (err) {
            console.warn(err);
            onAbort && onAbort(err);
        });
    }, 0)
}

VueRouter.prototype.replace = function replace(location, onComplete, onAbort) {
    // 未进入应用之前
    if (!fr.hasRouteIns) {
        let hashPath = window.location.hash.slice(1)
        if (hashPath == location) {
            return false
        } else {
            fr.isReady = false
            this._replace(location, onComplete, onAbort, "")
        }
    } else {
        this._replace(location, onComplete, onAbort, "forward")
    }
}


// 对vue-router功能的一些扩展
VueRouter.prototype.formatLocation = function formatLocation(location, routeMode, dire) {

    fr.direction = dire
    fr.routeMode = routeMode

    if (typeof location === 'string') {
        location = {
            path: location
        }
    }

    if (!location.query) {
        location.query = {};
    }

    return location;
}

let vxRouter = {
    transRoutes: transRoutes
}

export default vxRouter